<template>
    <div class="mdi-icon">
        <svg viewBox="0 0 24 24">
            <path fill="currentColor" :d="icon" />
        </svg>
    </div>
</template>

<script setup>
defineProps({
    icon: {
        type:     String,
        required: true,
    },
});
</script>
